import { ReactNode } from 'react';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useDevice } from '@/hooks/useDevice/useDevice';
import { cn } from '@/utils/cn';
import { FlexContainer } from '@cof/omni-react';
import styled from '@emotion/styled';

const MessageScreenTitle = styled('h3')<{
  fontSize: number;
  isMobile: boolean;
}>`
  font-size: ${(props) => props.fontSize}px;
  font-weight: 600;
  padding: 0 32px;
  align-self: ${({ isMobile }) => (isMobile ? 'flex-start' : '')};
`;

const MessageScreenHeader = styled('header')`
  width: 100vw;
  padding: 32px 32px 32px;
  display: flex;
  justify-content: center;
`;

const MessageScreenBody = styled('div')<{ isMobile: boolean }>`
  white-space: pre-line;
  padding: 0px 32px 32px;
  align-self: ${({ isMobile }) => (isMobile ? 'flex-start' : '')};
`;

export const MessageScreen = ({
  iconPath,
  iconSize,
  title,
  titleSize,
  body,
  button,
  isButtonAtBottom = false,
}: {
  iconPath?: string;
  iconSize?: number;
  title: string;
  titleSize: number;
  body: ReactNode;
  button?: ReactNode;
  isButtonAtBottom?: boolean;
}) => {
  const { content, theme } = useConfig();
  const { isMobile } = useDevice();

  return (
    <FlexContainer
      data-testid="MessageScreen"
      className={cn('bg-page')}
      direction="column"
      minHeight={window.innerHeight}
      alignItems="center"
      justifyContent={isButtonAtBottom ? 'space-between' : 'flex-start'}
      padding="large"
    >
      <FlexContainer direction="column" alignItems="center">
        <MessageScreenHeader data-testid="MessageScreen--Header">
          <img
            src={`${content.config.urlBase}${theme.logo.img.src}`}
            width={theme.logo.img.width}
            alt="logo"
            role="presentation"
          />
        </MessageScreenHeader>
        {iconPath && (
          <img src={iconPath} width={iconSize} alt="icon" role="presentation" />
        )}
        <MessageScreenTitle
          fontSize={titleSize}
          className={cn('text-neutral-primary')}
          isMobile={isMobile}
        >
          {title}
        </MessageScreenTitle>
        <MessageScreenBody
          className={cn('text-neutral-primary')}
          isMobile={isMobile}
        >
          {body}
        </MessageScreenBody>
        {!isButtonAtBottom && button}
      </FlexContainer>
      {isButtonAtBottom && button}
    </FlexContainer>
  );
};
